import { defineComponent as p, openBlock as o, createElementBlock as l, mergeProps as h, unref as e, renderSlot as i, createElementVNode as n, createCommentVNode as m } from "vue";
import { useScalarIcon as V } from "../hooks/useScalarIcon.js";
const H = { key: 0 }, g = { key: 1 }, Z = { key: 2 }, A = { key: 3 }, f = { key: 4 }, v = { key: 5 }, M = {
  name: "ScalarIconNumberFour"
}, y = /* @__PURE__ */ p({
  ...M,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: a } = V(s);
    return (u, t) => (o(), l("svg", h({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(d)), [
      i(u.$slots, "default"),
      e(a) === "bold" ? (o(), l("g", H, t[0] || (t[0] = [
        n("path", { d: "M184,156H172V48a12,12,0,0,0-21.37-7.5l-96,120A12,12,0,0,0,64,180h84v28a12,12,0,0,0,24,0V180h12a12,12,0,0,0,0-24Zm-36,0H89l59-73.79Z" }, null, -1)
      ]))) : e(a) === "duotone" ? (o(), l("g", g, t[1] || (t[1] = [
        n("path", {
          d: "M216,40V216a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V40A16,16,0,0,1,56,24H200A16,16,0,0,1,216,40Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M184,160H168V48a8,8,0,0,0-14.25-5l-96,120A8,8,0,0,0,64,176h88v32a8,8,0,0,0,16,0V176h16a8,8,0,0,0,0-16Zm-32,0H80.64L152,70.81Z" }, null, -1)
      ]))) : e(a) === "fill" ? (o(), l("g", Z, t[2] || (t[2] = [
        n("path", { d: "M104.65,144,144,94.81V144ZM216,40V216a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V40A16,16,0,0,1,56,24H200A16,16,0,0,1,216,40ZM184,152a8,8,0,0,0-8-8H160V72a8,8,0,0,0-14.25-5l-64,80A8,8,0,0,0,88,160h56v24a8,8,0,0,0,16,0V160h16A8,8,0,0,0,184,152Z" }, null, -1)
      ]))) : e(a) === "light" ? (o(), l("g", A, t[3] || (t[3] = [
        n("path", { d: "M184,162H166V48a6,6,0,0,0-10.69-3.75l-96,120A6,6,0,0,0,64,174h90v34a6,6,0,0,0,12,0V174h18a6,6,0,0,0,0-12Zm-30,0H76.48L154,65.1Z" }, null, -1)
      ]))) : e(a) === "regular" ? (o(), l("g", f, t[4] || (t[4] = [
        n("path", { d: "M184,160H168V48a8,8,0,0,0-14.25-5l-96,120A8,8,0,0,0,64,176h88v32a8,8,0,0,0,16,0V176h16a8,8,0,0,0,0-16Zm-32,0H80.64L152,70.81Z" }, null, -1)
      ]))) : e(a) === "thin" ? (o(), l("g", v, t[5] || (t[5] = [
        n("path", { d: "M184,164H164V48a4,4,0,0,0-7.12-2.5l-96,120A4,4,0,0,0,64,172h92v36a4,4,0,0,0,8,0V172h20a4,4,0,0,0,0-8Zm-28,0H72.32L156,59.4Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  y as default
};
